// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6pBfy","col":"styles_col__ES-9Q"};